import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { Project } from '../core/objects/project';
import { PalletOverflowRecommendationService } from '../core/services/pallet-overflow-recommendation.service';
import { ProjectService } from '../core/services/project.service';
import { SharedProjectService } from './../core/services/shared-project.service';
import { FADE_IN_OUT_ANIMATION } from './../shared/animations/animations';

@Component({
    selector: 'gl-main-panel',
    templateUrl: './main-panel.component.html',
    styleUrls: ['./main-panel.component.scss'],
    animations: [FADE_IN_OUT_ANIMATION],
    standalone: false
})
export class MainPanelComponent {
  @HostBinding('@show') public show;
  public activeMenuItem: number;
  @ViewChild('addLoadOpener', { static: false, read: ElementRef }) public openAddLoadEl: ElementRef;
  @ViewChild('addLoadingSpacesOpener', { static: false, read: ElementRef })
  public openAddLoadingSpacesEl: ElementRef;
  public isQuickLoadOpen = false;
  public isQuickLoadingSpaceOpen = false;
  public project: Project;

  constructor(
    private sharedProjectService: SharedProjectService,
    public projectService: ProjectService,
    private palletOverflowRecommendation: PalletOverflowRecommendationService,
  ) {
    this.projectService.project.subscribe((project) => (this.project = project));
    this.palletOverflowRecommendation.closeAddLoadUi.subscribe(() => {
      this.closeAddLoads();
      this.closeQuickAddLoads();
    });
  }

  public isViewingSharedProject() {
    return this.sharedProjectService.isViewingShared;
  }

  public openAddLoads() {
    this.isQuickLoadOpen = false;
    this.isQuickLoadingSpaceOpen = false;
    if (this.activeMenuItem === MenuItems.AddLoads) {
      this.closeAddLoads();
      return;
    }
    this.activeMenuItem = MenuItems.AddLoads;
    this.syncAddLoadUiOpen();
  }

  public toggleQuickLoadingSpace(): void {
    this.closeAddLoadingSpaces();
    this.isQuickLoadOpen = false;
    this.isQuickLoadingSpaceOpen = !this.isQuickLoadingSpaceOpen;
    this.syncAddLoadUiOpen();
  }

  public toggleQuickLoad(): void {
    this.closeAddLoads();
    this.isQuickLoadingSpaceOpen = false;
    this.isQuickLoadOpen = !this.isQuickLoadOpen;
    this.syncAddLoadUiOpen();
  }

  public closeAddLoads() {
    this.activeMenuItem = null;
    this.syncAddLoadUiOpen();
  }

  public closeQuickAddLoads(): void {
    this.isQuickLoadOpen = false;
    this.syncAddLoadUiOpen();
  }

  public closeQuickAddLoadingSpaces(): void {
    this.isQuickLoadingSpaceOpen = false;
  }

  public closeAddLoadingSpaces() {
    this.activeMenuItem = null;
    this.syncAddLoadUiOpen();
  }

  public openAddLoadingSpaces() {
    this.isQuickLoadingSpaceOpen = false;
    this.isQuickLoadOpen = false;
    if (this.activeMenuItem === MenuItems.AddLoadingSpaces) {
      this.closeAddLoadingSpaces();
      return;
    }
    this.activeMenuItem = MenuItems.AddLoadingSpaces;
    this.syncAddLoadUiOpen();
  }

  public isAddLoadsActive() {
    return this.activeMenuItem === MenuItems.AddLoads;
  }

  public isAddLoadingSpacesActive() {
    return this.activeMenuItem === MenuItems.AddLoadingSpaces;
  }

  private syncAddLoadUiOpen(): void {
    this.palletOverflowRecommendation.setAddLoadUiOpen(
      this.isAddLoadsActive() || this.isQuickLoadOpen,
    );
  }
}

enum MenuItems {
  AddLoads,
  AddLoadingSpaces,
}
